import { render, staticRenderFns } from "./ControlProductList.vue?vue&type=template&id=4bc30180&scoped=true&"
import script from "./ControlProductList.vue?vue&type=script&lang=ts&"
export * from "./ControlProductList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc30180",
  null
  
)

export default component.exports